<template>
  <TableList
    ref="TableList"
    v-loading="listLoading"
    :dataList="list"
    :columnAllData="columnAllData"
    :tableName="TableName"
    :permissionName="permissionName"
    :showSelection="false"
    :canRefresh="false"
    :canChangeColumn="false"
    :canCommand="false"
    :isShowPagination="false"
    :handleDefaultWidth="240"
    :maxHight="224"
    >
  </TableList>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElForm } from 'element-plus'

import { businessConcatsList } from '@/apis/Business'
import { getDropdown } from '@/apis/Dictionary'
import { getDropdownByType } from '@/apis/tool'

import { CostModel } from '@/model/Index'

import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Concat',
  components: {
    TableList
  },
  props: {
    id: { type: Number, required: true, default: 0 }
  },
  setup(props) {
    const { t } = useI18n()
    const TableList = ref(null)
    const setForm = ref(ElForm)

    const dataMap = reactive({
      TableName: TableName.TABLE_BUSINESS_CONTACT,
      permissionName: permissionName.OUTSOURCE_COMPANY_CONTACT,
      columnAllData: TableField,

      activeId: 0,
      list: [],
      listLoading: false,
      dialogFormVisible: false,
      submitLoading: false,
      getList() {
        if (!props.id) {
          dataMap.list = []
          return
        }
        dataMap.listLoading = true
        businessConcatsList(props.id).then((res: any) => {
          dataMap.list = res || []
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      getDropdownByType() {
        getDropdownByType('ReviewStatus').then((res: any) => {
          dataMap[`${'ReviewStatus'}Option`] = res
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 2 && column.url) {
            getDropdown(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          } else if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      }
    })

    watch(() => props.id, () => {
      dataMap.getList()
    })

    onMounted(async() => {
      await dataMap.loadTableSelectOption()
      dataMap.getList()
      dataMap.loadDropdownList('customerLevel')
      dataMap.loadDropdownList('customerSource')
      dataMap.loadDropdownList('paymentCycle')
      dataMap.getDropdownByType()
    })
    return { TableList, t, ...toRefs(dataMap), setForm }
  }
})
</script>
